
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';

const SearchBar = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/explore?search=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery(''); // Clear the search input after submitting
    }
  };

  return (
    <form onSubmit={handleSearch} className="relative hidden md:flex items-center">
      <Search className="absolute left-3 h-4 w-4 text-gray-500 z-10" />
      <input 
        type="text" 
        placeholder="Search papers..." 
        className="h-9 w-[200px] md:w-[320px] rounded-lg bg-white/60 backdrop-blur-sm pl-9 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 border border-border/40 focus:border-primary/30 transition-all shadow-sm"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
    </form>
  );
};

export default SearchBar;
